import { call, put } from "redux-saga/effects";

import { getContactUsRequest, sendContact } from "../../api/not-sorted";
import { CFStatus, ComponentsId, TOAST_TYPE } from "../../constants";
import { consoleLogError } from "../../utils/console";
import { _sharedActionsSystem } from "../system/actions";
import { _sharedActionsSupport } from "./actions";

const scope = "Shared Saga Support";

export function* _sharedWorkerFetchCF() {
  try {
    const response = yield call(getContactUsRequest);
    const contactTypes = response.data[0].contacts.map((item) => ({
      ...item,
      id: item.tag,
    }));
    yield put(_sharedActionsSupport.actionFetchCFSuccess(contactTypes));
  } catch (error) {
    consoleLogError(scope, "Error: ", error);
  }
}

export function* _sharedWorkerSendCF(action) {
  try {
    yield put(_sharedActionsSystem.loading(ComponentsId.CF_SEND_ID));
    const response = yield call(sendContact, action.data);

    if (response.status === 202) {
      yield put(_sharedActionsSupport.actionSendCFStatus(CFStatus.SUCCESS));
    } else {
      yield put(_sharedActionsSupport.actionSendCFStatus(CFStatus.ERROR));
    }
  } catch (error) {
    consoleLogError(scope, "Error: ", error);
    yield put(_sharedActionsSystem.toast("Can't send contact data", TOAST_TYPE.error));
  } finally {
    yield put(_sharedActionsSystem.loading(ComponentsId.CF_SEND_ID, true));
  }
}
